import { RowCrudStatus } from "../../common/types";
import {
  ProvinceState,
  ProvinceStateCreateMutationVariables,
  ProvinceStateUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { countryDisplayId } from "../../country/store/CountryCommonStore";

export type ProvinceStateValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name_es: string;
  name_en: string;
  name_pt: string;
  __country: string;
  showCountry: { displayId: string; id: string } | null;
};

export type ProvinceStateErrorsType = {
  name_es?: { message: string; fieldLabel: string };
  name_en?: { message: string; fieldLabel: string };
  name_pt?: { message: string; fieldLabel: string };
  country?: { message: string; fieldLabel: string };
};

export function ProvinceStateValuesInit(): ProvinceStateValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name_es: "",
    name_en: "",
    name_pt: "",
    __country: "",
    showCountry: null,
  };
}

export type ProvinceStateType = ProvinceState | ProvinceStateValuesType;

export function provinceStateDisplayId(
  source: Partial<ProvinceState>,
  _langStore: LangStore
) {
  return `${source[_langStore.fieldByLang("name") as keyof ProvinceStateType]}`;
}

export function getProvinceStateValues(
  source: ProvinceStateType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ProvinceStateValuesType {
  const entityValues = ProvinceStateValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : provinceStateDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name_es = source.name_es;
  entityValues.name_en = source.name_en;
  entityValues.name_pt = source.name_pt;
  entityValues.showCountry =
    "country" in source && source.country
      ? {
          id: source.country.id,
          displayId: countryDisplayId(source.country, _langStore),
        }
      : "showCountry" in source && source.showCountry
      ? { id: source.showCountry.id, displayId: source.showCountry.displayId }
      : null;
  entityValues.__country = entityValues.showCountry?.displayId || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getProvinceStateUpdateVariables(
  values: ProvinceStateValuesType
): ProvinceStateUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    countryId: values.showCountry?.id || "",
  };
}

export function getProvinceStateCreateVariables(
  values: ProvinceStateValuesType
): ProvinceStateCreateMutationVariables {
  return {
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    countryId: values.showCountry?.id || "",
  };
}
